module.exports = "table {\n  white-space: nowrap; }\n\n.table-div {\n  max-width: 100%;\n  overflow: auto; }\n\n.text-div {\n  max-height: 150px;\n  max-width: 100%;\n  overflow: auto; }\n\n.wrap-historic {\n  height: 500px;\n  overflow: auto; }\n\n.fix-size {\n  max-height: 500px;\n  overflow: auto; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/billing-control/bc-account-client/bc-juridical-proposal/bc-juridical-proposal.component.scss
// module id = ./src/app/billing-control/bc-account-client/bc-juridical-proposal/bc-juridical-proposal.component.scss
// module chunks = main